import { render, staticRenderFns } from "./ReviewFooter.vue?vue&type=template&id=866eecfa&scoped=true"
import script from "./ReviewFooter.vue?vue&type=script&lang=ts"
export * from "./ReviewFooter.vue?vue&type=script&lang=ts"
import style0 from "./ReviewFooter.vue?vue&type=style&index=0&id=866eecfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866eecfa",
  null
  
)

export default component.exports